import {createSlice} from "@reduxjs/toolkit";

interface IInitState {
    query: string | undefined | null
    visit_date: boolean | undefined | 'all'
    page:number | undefined
    date:string

}

const initialState: IInitState = {
    query: undefined,
    visit_date: undefined,
    page:1,
    date:''
}

const monthDataReducer = createSlice({
    name: 'monthData',
    reducers: {
        setMonthFilterData: (state, {payload}) => {
            if (payload.query || payload.query === '') {
                state.query = payload.query
            }
            if (payload.visit_date || payload.visit_date !== 'all') {
                state.visit_date = payload.visit_date
            }
            if (payload.visit_date === 'all') {
                state.visit_date = undefined
            }
            if (payload.query === '') {
                state.query = undefined
            }
            if (payload.page||payload.page===undefined) {
                state.page = payload.page
            }

        },
        clearMonthQueryFilterData: (state) => {
            state.query = undefined
            state.visit_date = undefined
            state.page = undefined
        },
        clearMonthQuery: (state) => {
            state.query = undefined
            state.visit_date = undefined
        },
        setUrlParams: (state, {payload}) => {
            if (payload.date) {
                state.date = payload.date
            }
        },
    },
    initialState,

})

export const {setMonthFilterData, clearMonthQueryFilterData, clearMonthQuery, setUrlParams} = monthDataReducer.actions

export default monthDataReducer.reducer
